import { render, staticRenderFns } from "./VMSTextField.vue?vue&type=template&id=736e42b0"
import script from "./VMSTextField.vue?vue&type=script&lang=ts"
export * from "./VMSTextField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports